import { SysRolePageAction } from "./sys-role-page-action";

export class UserRolePageAction {
  userPageActionId!: number;
  sysRolePageAction!: SysRolePageAction;
  isEnabled!: boolean;
}
